const INTERNAL_API_URL =
  process.env.REACT_APP_INTERNAL_API_URL ||
  "//territorioyacopini.com.ar/api/v2";

//process.env.REACT_APP_INTERNAL_API_URL

export default INTERNAL_API_URL;
